// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"177":"home","186":"juz","237":"tafsir","839":"surah"}[chunkId] || chunkId) + "." + {"177":"adf1bb70","186":"b9d2b08b","237":"afbc2666","385":"6a63cb45","839":"515a8f32"}[chunkId] + ".js";
};